import styled from "styled-components";

interface ToggleProps
{
	toggleState: number;
}
interface ButtonToggleProps
{
	toggleState: number;
	checked: boolean;
}

export const Wrapper = styled.div<ToggleProps>`
	display: flex;
	justify-content: ${props => (props.toggleState === 0
		? "flex-start;"
		: props.toggleState === -1
			? "center;"
			: "flex-end;"
	)}
	align-items: center;
	width: 50px;
	height: 20px;
	border-radius: 999px;
	padding: 0 2px;
	background-color: ${props => (props.toggleState === 0
		? "#CC214F;"
		: props.toggleState === -1
			? "#908B8B;"
			: "#1bb3ad;"
	)};
    cursor: pointer;
`;
export const Button = styled.button<ButtonToggleProps>`
	width: 100%;
	opacity: 0;
	height: 70%;
	border-radius: 50%;
	border: none;
	cursor: pointer;

	box-shadow: rgb(101 119 134 / 20%) 0px 0px 15px, rgb(101 119 134 / 15%) 0px 0px 3px 1px;

	${props => props.checked && { opacity: "1" }}
`;
export const StateText = styled.span<ToggleProps>`
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 12px;
	color: white;
	padding: 0 5px;
`;
export const ToggleCircle = styled.div<ToggleProps>`
	height: 16px;
	width: 16px;
	border-radius: 50%;
	background-color: white;
`
